module.exports = __webpack_public_path__ + "img/users-gray.ea01da78.svg";